document.addEventListener('DOMContentLoaded', () => {
  const mobileMenu = document.querySelector('.mobile-menu');

  if (mobileMenu) {
    const openMenu = () => {
      mobileMenu.style.display = 'block';

      setTimeout(() => {
        document.body.classList.add('drawer-open');
        mobileMenu.classList.add('mobile-menu--open');
      }, 10);
    }

    const closeMenu = () => {
      mobileMenu.classList.remove('mobile-menu--open');

      setTimeout(() => {
        mobileMenu.style.display = 'none';
        document.body.classList.remove('drawer-open');
      }, 300)
    }

    const triggers = document.querySelectorAll('.mobile-menu-trigger');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        openMenu();
      });
    });

    const closeButtons = document.querySelectorAll('.mobile-menu-close');

    closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const isOverlay = button.classList.contains('mobile-menu');

        if (isOverlay && event.target == button || !isOverlay) {
          closeMenu();
        }
      });
    });

    const links = document.querySelectorAll('.mobile-nav__item-link[data-subnav-trigger]');
    let selectedLink = null;
    const navWrapper = mobileMenu.querySelector('.mobile-menu__nav-wrapper');
    navWrapper.style.display = 'block';

    const title = document.querySelector('.mobile-menu__title');

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const subnav = document.getElementById(link.getAttribute('aria-controls'));

        if (subnav) {
          event.preventDefault();

          selectedLink = link;

          // Extract only the text content of the <a> element, excluding child elements like <svg>
          const linkText = link.childNodes[0].nodeValue.trim();
          title.textContent = linkText;
          
          subnav.style.display = 'block';

          setTimeout(() => {
            link.setAttribute('aria-expanded', 'true');
            subnav.classList.add('mobile-subnav--open');
            mobileMenu.classList.add('mobile-menu--subnav-open');
          }, 10);

          setTimeout(() => {
            navWrapper.style.display = 'none';
          }, 300);
        }
      });
    });

    const backButton = document.querySelector('.mobile-menu__back');

    if (backButton) {
      backButton.addEventListener('click', () => {
        navWrapper.style.display = 'block';
        selectedLink.setAttribute('aria-expanded', 'false');
        const selectedSubnav = document.getElementById(selectedLink.getAttribute('aria-controls'));
        selectedSubnav.classList.remove('mobile-subnav--open');

        setTimeout(() => {
          mobileMenu.classList.remove('mobile-menu--subnav-open');
        }, 10)

        if (selectedSubnav) {
          setTimeout(() => {
            selectedSubnav.style.display = 'none';
          }, 300);
        }

        title.textContent = '';
      });
    }
  }
})